import { Box, Button, Card, CardContent, CardMedia, Typography } from '@mui/material';
import { Circle, NotificationsNoneRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { BUY } from '../assets/constants/Constants';
import { getEquipmentPriceLabel } from '../lib/Utils';

const EquipmentCard = ({ title, description, image, availability, notifyMeButtonHandler, isRentedByUser,elapsedTime,showNotifyMeButton,productType,equipment }) => {
    const {t} = useTranslation();
    const notAvailableLabel = showNotifyMeButton
        ? t('notAvailableBtnLabel')
        : (productType === BUY ? t('purchased_by_me_btn_label') : t('rented_by_me_btn_label'));
    const productTypeLabel = productType === BUY ? t('buyProductTypeLabel') : t('rentProductTypeLabel');
    const priceLabel = getEquipmentPriceLabel(equipment, productType);

    const ProductTypeIndicator = () => (
        <Box className='product-type-indicator'>
            <Typography className='product-type-text'>{productTypeLabel}</Typography>
        </Box>
    );

    const PriceIndicator = () => (
        priceLabel ? (
            <Box className='product-type-indicator'>
                <Typography className='product-type-text'>{priceLabel}</Typography>
            </Box>
        ) : null
    );

    return (
        <Card className='equipment-card'>
            <CardContent className='card-content content-col-1'>
                <CardMedia 
                    component='img'
                    image={image}
                    alt='Product Image'
                    className='equipment-image'
                />
            </CardContent>
            <CardContent className='card-content content-col-2'>
                <Typography className='equipment-title'>{title}</Typography>
                <Typography className='equipment-description'>{description}</Typography>
                {isRentedByUser && productType !== BUY ? (
                    <Box className='timer-indicator-container'>
                        <ProductTypeIndicator />
                        <PriceIndicator />
                        <Box className='timer-indicator'>
                            <Typography className='timer-text'>{t('timeElapsedLabel')} {elapsedTime}</Typography>
                        </Box>
                    </Box>
                ) : (isRentedByUser || availability) ? (
                    <Box className='availability-indicator-container'>
                        <ProductTypeIndicator />
                        <PriceIndicator />
                        <Box className='availability-indicator available'>
                            <Circle className='circle-icon' />
                            <Typography className='availability-text'>{isRentedByUser ? notAvailableLabel : t('availableBtnLabel')}</Typography>
                        </Box>
                    </Box>
                ) : (
                    <Box className='availability-indicator-container'>
                        <ProductTypeIndicator />
                        <PriceIndicator />
                        <Box className='availability-indicator not-available'>
                            <Circle className='circle-icon' />
                            <Typography className='availability-text'>{notAvailableLabel}</Typography>
                        </Box>
                        {showNotifyMeButton ?
                        <Button
                            className='notify-me-button'
                            disableRipple={true}
                            startIcon={<NotificationsNoneRounded className='notification-icon' />}
                            onClick={notifyMeButtonHandler}
                        >{t('notifyMeBtnLabel')}</Button> : null}
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default EquipmentCard;
